import { leadMagnetData } from "../data/mock";
import { Download, Users, ArrowRight, Check, FileText, Building2 } from "lucide-react";

const cardIcons = [FileText, Building2, Users];

export const LeadMagnetSection = () => {
  return (
    <section id="lead-magnet" data-testid="lead-magnet-section" className="relative py-28" style={{ background: "#252422" }}>
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Section Header */}
        <div className="mb-14 text-center">
          <span className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            Free Resources
          </span>
          <h2 className="font-black uppercase leading-[0.88]" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.6rem, 1.2rem + 2vw, 2.8rem)", letterSpacing: "-0.02em" }}>
            <span className="text-[#888680]">Not ready to talk yet? </span>
            <span className="text-[#d9fb06]">Start here.</span>
          </h2>
        </div>

        {/* 3 Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {leadMagnetData.options.map((option, i) => {
            const Icon = cardIcons[i];
            return (
              <div key={i} className="bg-[#1a1c1b] border border-[#3f4816]/15 rounded-sm p-7 flex flex-col justify-between">
                <div>
                  {/* Icon */}
                  <div className="w-10 h-10 rounded-md bg-[#3f4816]/15 border border-[#3f4816]/25 flex items-center justify-center mb-5">
                    <Icon size={18} className="text-[#d9fb06]" />
                  </div>

                  {/* Title */}
                  <h3 className="text-[#dfddd6] font-bold text-base mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                    {option.title}
                  </h3>

                  {/* Subtitle */}
                  <p className="text-[#888680] text-sm leading-relaxed mb-4" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                    {option.subtitle}
                  </p>

                  {/* Bullets if any */}
                  {option.bullets.length > 0 && (
                    <div className="flex flex-col gap-1.5 mb-5">
                      {option.bullets.map((b, j) => (
                        <div key={j} className="flex items-start gap-2">
                          <Check size={12} className="text-[#d9fb06]/60 mt-0.5 flex-shrink-0" />
                          <p className="text-[#888680]/70 text-xs leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                            {b}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* CTA */}
                <div className="mt-4">
                  <a
                    href={option.ctaLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group w-full inline-flex items-center justify-center gap-2 bg-[#d9fb06] text-[#1a1c1b] font-semibold text-xs px-5 py-3 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 active:scale-[0.98] uppercase tracking-tight"
                    style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                  >
                    {i < 2 ? <Download size={13} /> : <Users size={13} />}
                    {option.ctaText}
                    <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5" />
                  </a>
                  <p className="text-[#888680]/50 text-[10px] text-center mt-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                    {option.microcopy}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
